import { Component, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { CartService } from '../services/cart.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'app-cart-dashboard',
	templateUrl: './cart-dashboard.component.html'
})

export class CartDashboardComponent implements OnInit {

	public cart: any = null;
	public items = {};
	public services = [];
	public cartUuid: String = '';
	public cartLoading = true;
	public objectKeys = null;
	public cartSum: any = 0.00;
	public cartSumMonthly: any = 0.00;
	public invoices: String = null;

	constructor(
		private cartService: CartService,
		private route: ActivatedRoute,
		private router: Router,
		private notificationsService: NotificationsService,
	) {
		this.cartLoading = true;
		this.objectKeys = Object.keys;
	}

	ngOnInit() {
		this.cartLoading = true;
		this.cart = null;
		this.items = [];
		this.invoices = null;
		this.route.params.subscribe(params => {
			this.cartUuid = params['id'];
			this.cartService.getDashboardData(this.cartUuid).subscribe(
				response => {
					if (response.status.message == 'shopping-cart.show') {
						this.cart = response.data.shopping_cart;
						this.items = this.parseItemsForList(response.data.items);
						this.invoices = response.data.invoices;
					}
					this.cartLoading = false;
				},
				error => {
					this.router.navigateByUrl('/cart/list');
					this.cart = null;
					this.cartLoading = false;
				}
			)
		});
	}

	parseItemsForList(items) {
		let formatedItems = {};
		this.cartSum = 0;
		this.cartSumMonthly = 0;
		for (const key of this.objectKeys(items)) {
			if (items.hasOwnProperty(key)) {
				let nameAndUuid = key.split('#');
				this.services.push(nameAndUuid[0]);
				for (const item of items[key]) {
					this.cartSum = this.cartSum + (item.single ? 0 : item.count * item.netto);
					this.cartSumMonthly = this.cartSumMonthly + (item.single ? item.count * item.netto : 0);
					if (formatedItems[nameAndUuid[0]]) {
						formatedItems[nameAndUuid[0]].push(item);
						continue;
					}
					formatedItems[nameAndUuid[0]] = [item];
				}
			}
		}
		return formatedItems;
	}

	removeCart() {
		this.cartService.removeCart(this.cartUuid).subscribe(response => {
			if (response.status.message == 'shopping-cart.removed') {
				this.router.navigateByUrl('/cart/list');
			}
		});
	}


	finalizeCart() {
		if (this.cartService.setCart(this.cartUuid)) {
			this.router.navigateByUrl('/service/offer/company');
			return;
		}
		this.notificationsService.error('Ups!', 'Wystąpił problem z koszykiem, lista zostanie odświeżona. Spróbuj ponownie za chwilę');
		return;
	}
}



// WEBPACK FOOTER //
// ./src/app/cart/cart-dashboard.component.ts